import { render, staticRenderFns } from "./RetailsView.vue?vue&type=template&id=0030a601"
import script from "./RetailsView.vue?vue&type=script&lang=js"
export * from "./RetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports